export function filterTeams(teams,teamId='',period='') {
    return teams.filter(team=>!teamId||String(team.teamId)===String(teamId)).map(team=>({...team,periods:team.periods.filter(group=>(!period||String(group.period)===String(period))&&group.items.length)})).filter(team=>team.periods.length);
}
export function maskMobile(mobile) {
    const value=String(mobile||'');return value.length>4?'****'+value.slice(-4):value;
}
export function courseCsv({seminarId,chats,socratic,teamLabel,t,formatTime}) {
    const rows=[[t('facilitator.seminarLabel'),t('facilitator.team'),t('facilitator.teamId'),t('facilitator.period'),t('facilitator.recordType'),t('facilitator.student'),t('facilitator.createdAt'),t('facilitator.questionContent'),t('facilitator.answerContent'),t('facilitator.answeredAt')]];
    for(const [type,teams] of [['chat',chats],['socratic',socratic]])for(const team of teams)for(const group of team.periods)for(const item of group.items){
        const label=t(type==='chat'?'facilitator.chatTab':'facilitator.socraticTab')+(item.isTrigger?' · '+t('facilitator.automaticTrigger'):'');
        rows.push([seminarId,teamLabel(team.teamId),team.teamId,group.period,label,maskMobile(item.userMobile||item.answerMobile),formatTime(item.createdAt),item.question,item.answer||t(type==='chat'?'facilitator.noReply':'facilitator.unanswered'),formatTime(item.answeredAt)]);
    }
    const escape=value=>{
        let text=String(value??'');
        if(/^[\s\uFEFF]*[=+@-]/.test(text))text="'"+text;
        return '"'+text.replace(/"/g,'""')+'"';
    };
    return '\uFEFF'+rows.map(row=>row.map(escape).join(',')).join('\r\n');
}
